/** @file The 11 pitch thresholds that cut the circle into 12 bands; band 4 is level (design 4.3). */

/** Band i = pitch below threshold i and at or above threshold i-1; at or above 195 is band 11. */
export const PITCH_THRESHOLDS: readonly number[] = [-105, -75, -45, -15, 15, 45, 75, 105, 135, 165, 195];
